import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {ApplicationPackage} from '../../../enums/application-package.enum';
import {Service} from '../../../enums/service.enum';
import {Observable} from 'rxjs';
import {PackagePresetP} from 'src/app/model/encoder-manager/package-preset.model';

@Injectable({
  providedIn: 'root',
})
export class PackageProfilesService {
  readonly packageUrl = environment.endPoint + ApplicationPackage.CMS_VOD + Service.ENCODER;

  constructor(private http: HttpClient) {}

  getAllPackagePresets(): Observable<PackagePresetP[]> {
    return this.http.get<PackagePresetP[]>(this.packageUrl + '/packagepreset');
  }

  createPackagePreset(packagePreset: PackagePresetP): Observable<PackagePresetP> {
    return this.http.post<PackagePresetP>(this.packageUrl + '/packagepreset', packagePreset);
  }

  getPackagePresetById(packagePresetId: number): Observable<PackagePresetP> {
    return this.http.get<PackagePresetP>(this.packageUrl + `/packagepreset/${packagePresetId}`);
  }

  updatePackagePreset(packagePreset: PackagePresetP): Observable<PackagePresetP> {
    return this.http.put<PackagePresetP>(this.packageUrl + '/packagepreset', packagePreset);
  }

  deletePackagePreset(packagePresetId: number): Observable<PackagePresetP> {
    return this.http.delete<PackagePresetP>(this.packageUrl + `/packagepreset/${packagePresetId}`);
  }
}
